import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from '../cfg/cfg.service';
import { ServerAddressesCfgService } from '../util/serverAddressesCfg.service';

export class DashboardCfg {
  public resourceId: number;
  public showDasboardRecruitment: number;
}

@Injectable()
export class DashboardCfgService extends CfgService<DashboardCfg> {
  json: any = {
    resourceId: 1111,
    showDasboardRecruitment: "%{ShowDashboardRecruitment}"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/dashboard.cfg.json`;
  }

  /**
   * Carga las url en el json
   */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
